import React from 'react'

import PageLayout from '@/CandidateExperience/components/PageLayout'

import JobDetails from '@/Jobs/components/JobDetails'
import DetailsBreadcrumb from '@/Jobs/components/DetailsBreadcrumb'
import RecommendationFeedbackBanner from '@/Jobs/components/RecommendationFeedbackBanner/BannerContent'
import { useRecommendationFeedbackBanner } from '@/Jobs/components/RecommendationFeedbackBanner/hooks'

const JobDetailsScene = () => {
  const { isFeedbackSubmitted, isSubmittingFeedback, submitFeedback, isBannerVisible, bannerTheme, isValidRecommendation } =
    useRecommendationFeedbackBanner()

  return (
    <PageLayout
      body={<JobDetails />}
      toolbarContent={<DetailsBreadcrumb />}
      notificationBannerContent={
        isBannerVisible && (
          <RecommendationFeedbackBanner
            isFeedbackSubmitted={isFeedbackSubmitted}
            isSubmittingFeedback={isSubmittingFeedback}
            submitFeedback={submitFeedback}
            isValidRecommendation={isValidRecommendation}
          />
        )
      }
      notificationBannerTheme={bannerTheme}
    />
  )
}

export default JobDetailsScene
